__turbopack_context__.v({
  "bannerTopo": "AKdtNa_bannerTopo",
  "blue": "AKdtNa_blue",
  "blueLight": "AKdtNa_blueLight",
  "btn": "AKdtNa_btn",
  "containerBtns": "AKdtNa_containerBtns",
  "containerTxTBanner": "AKdtNa_containerTxTBanner",
  "dpFlex": "AKdtNa_dpFlex",
  "heading": "AKdtNa_heading",
  "highlight": "AKdtNa_highlight",
  "imgLoop": "AKdtNa_imgLoop",
});
